export default __webpack_public_path__ + "static/media/G-2.57217c11.svg";